module.exports = __webpack_public_path__ + "static/image-02-a@2x-f52d03a708c39df5a5179d117a828227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-02-a@2x.jpg
// module id = 365
// module chunks = 3627797113349 20562973939449 33019919093843